export default __webpack_public_path__ + "static/media/new_m2_test_ntF.f7512fec.png";